import { FC } from 'react';

import Card from 'components/atoms/Card';
import CardBorderHeading, { CardBorderHeadingProps } from 'components/atoms/CardBorderHeading';

interface Props {
  cardBorderHeadingProps?: CardBorderHeadingProps;
  heading: CardBorderHeadingProps['heading'];
  headingText: CardBorderHeadingProps['headingText'];
}

const CardWithBorderHeading: FC<Props> = ({ children, headingText, heading }) => (
  <CardBorderHeading headingText={headingText} heading={heading} borderRadiusType="round">
    <Card>{children}</Card>
  </CardBorderHeading>
);

export type { Props as CardWithBorderHeadingProps };
export default CardWithBorderHeading;
